import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('CLIENT_RECORD')